import { Grid } from "@mui/material"
import Header from "components/Header/Header"
import AppButton from "components/StyledComponents/AppButton"
import { Formik } from "formik"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import { validationSchemaAdvertisement } from "helpers/validationSchema"
import React, { useEffect, useState } from "react"
import CreateAdvertisement from "./components/CreateAdvertisement"
import AdvertisementList from "./components/AdvertisementList"
import { Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import {
  addAdvertisementsAction,
  getAdvertisementsAction,
  updateAdvertisementsAction
} from "redux/superAdmin/actions"
import { convertDate, payloadDate } from "helpers/functions"
import { superAdminAction } from "redux/superAdmin/slice/user"

const initialValues = {
  heading: "",
  tile_heading: "",
  drawer_title: "",
  image: "",
  restaurants: [],
  start_date: "",
  end_date: "",
  details: "",
  ad_start_date: "",
  ad_end_date: ""
}

const Advertisement = () => {
  const dispatch = useDispatch()
  const [breadCrumbs, setBreadcrumbs] = useState([])
  const [initValues, setInitValues] = useState(initialValues)
  const [currentPage, setCurrentPage] = useState(1)
  const [openModal, setopenModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const { advertisements, advertisementDetails } = useSelector((state) => state.superAdmin)
  const { notificationImageId } = useSelector((store) => store?.superAdmin?.notifications || [])

  const handleAddAdvertisement = () => {
    setInitValues(initialValues)
    setIsEdit(false)
    setopenModal(true)
  }

  const handleCloseModal = () => {
    setIsEdit(false)
    setopenModal(false)
    dispatch(superAdminAction?.setNotificationImageId(""))
  }

  function handleEditAdvertisement() {
    setIsEdit(true)
    setopenModal(true)
  }

  const handleSubmit = (e) => {
    const currentTime = new Date().toISOString().split("T")[1].split(".")[0]

    const getPayloadDate = (date) => {
      if (!date) return ""
      return payloadDate(convertDate(date, currentTime).split(" "))
    }

    const payload = {
      banner_heading: e?.heading,
      tile_heading: e?.tile_heading,
      drawer_title: e?.drawer_title,
      ...(notificationImageId
        ? { background_image: notificationImageId }
        : e.image?.url
        ? { background_image: e?.image?.url }
        : { background_image: "" }),
      restaurants: e?.restaurants,
      start_date: getPayloadDate(e?.start_date),
      end_date: getPayloadDate(e?.end_date),
      ad_start_date: getPayloadDate(e?.ad_start_date),
      ad_end_date: getPayloadDate(e?.ad_end_date),
      additional_details: e?.details
    }

    if (!isEdit) {
      dispatch(addAdvertisementsAction({ payload, onClose: handleCloseModal }))
    } else {
      dispatch(
        updateAdvertisementsAction({
          id: advertisementDetails?.id,
          payload,
          onClose: handleCloseModal
        })
      )
    }
  }

  const itemsPerPage = 12
  const totalPages = Math.ceil(advertisements?.length / itemsPerPage)
  const paginatedList =
    Array.isArray(advertisements) &&
    advertisements?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)

  useEffect(() => {
    setBreadcrumbs(createBreadcrumbs())
    document.title = "Advertisements"
    dispatch(getAdvertisementsAction())
    dispatch(superAdminAction?.setNotificationImageId(""))
  }, [])

  useEffect(() => {
    const val = {
      heading: advertisementDetails?.banner_heading || "",
      tile_heading: advertisementDetails?.tile_heading || "",
      drawer_title: advertisementDetails?.drawer_title || "",
      image: advertisementDetails?.background_image_url
        ? {
            id: "",
            url: advertisementDetails?.background_image_url ?? ""
          }
        : "",
      restaurants: advertisementDetails?.restaurants?.map((item) => item.id) || [],
      start_date: advertisementDetails?.start_date || "",
      end_date: advertisementDetails?.end_date || "",
      ad_start_date: advertisementDetails?.ad_start_date || "",
      ad_end_date: advertisementDetails?.ad_end_date || "",
      details: advertisementDetails?.additional_details || ""
    }
    setInitValues(val)
    dispatch(superAdminAction?.setNotificationImageId(advertisementDetails?.background_image))
  }, [advertisementDetails])

  return (
    <div>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={12}>
            <Header title="Advertisements" breadCrumbs={breadCrumbs}>
              <AppButton onClick={() => handleAddAdvertisement()} sx={{ padding: "13px 36px" }}>
                + Create New Advertisement
              </AppButton>
            </Header>
          </Grid>
          <Container style={{ minWidth: "100%" }}>
            <Row style={{ width: "100%", overflow: "auto" }}>
              <Col lg="12" className="p-0">
                <AdvertisementList
                  setPage={setCurrentPage}
                  currentPage={currentPage}
                  totalPage={totalPages}
                  rows={paginatedList || []}
                  columns={columns}
                  handleEditAdvertisement={handleEditAdvertisement}
                />
              </Col>
            </Row>
          </Container>
        </Grid>
        {openModal && (
          <Formik
            onSubmit={handleSubmit}
            validationSchema={validationSchemaAdvertisement}
            initialValues={initValues}>
            {(formik) => (
              <CreateAdvertisement
                isEdit={isEdit}
                onClose={handleCloseModal}
                formik={formik}
                open={openModal}
              />
            )}
          </Formik>
        )}
      </Grid>
    </div>
  )
}

export default Advertisement

const columns = [
  {
    id: "Advertisement Name",
    label: "Advertisement Name",
    minWidth: 250
  },
  {
    id: "Tile Heading",
    label: "Tile Heading",
    minWidth: 200
  },
  {
    id: "Advertisement Date & Time",
    label: "Advertisement Date & Time",
    align: "center",
    minWidth: 150
  },
  {
    id: "Event Date & Time",
    label: "Event Date & Time",
    align: "center",
    minWidth: 150
  },
  {
    id: "Actions",
    label: "Actions",
    align: "center",
    minWidth: 80
  }
]
